import styled from 'styled-components';

const ServiceProviderCard = styled.a`
  width: 300px;
  height: 200px;
  margin: 1em;
  flex: 0 0 300px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  word-break: break-word;
  text-align: center;
  padding: 1em;
  background: #fff;
  transition: all 0.125s ease-in-out;

  &:hover {
    box-shadow: 2px 4px 8px rgba(0,0,0,.2);
    background: #f5f5f2;
  }
`;

const ServiceProviderTitle = styled.span`
  font-size: 2em;
  font-weight: bold;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  margin-bottom: 1em;
  color: #207C9D;
  font-weight: 300;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const ListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
`;

const AdminMasthead = styled.div`
  min-height: 300px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #004A5E;
  color: #fff;
  font-size: 2em;
  word-break: break-word;
  flex-direction: column;
`;

const AdminContentContainer = styled.div`
  padding: 0 1em 2em 1em;
  justify-content: flex-end;
`;

const Table = styled.table`
  text-align: left;
  margin: 1em;
  tbody {
    tr {
      height: 2em;
      &:nth-child(odd) {
        background: #efefef;
      }
    }
    td {
      padding: 8px;
    }
  }
`;

export {
  ServiceProviderCard,
  ServiceProviderTitle,
  PageHeader,
  ListContainer,
  AdminMasthead,
  AdminContentContainer,
  Table,
}
